import theme from "@irati/ui/src/global/theme"
import {FormatMessage} from "@irati/utils/lang/types"
import {IconTypes} from "@irati/ui/src/Icon"
import Products from "@irati/products/enums/Products"
import {ctwURL, heURL, alpURL} from "@irati-web/benefits"

type ProductList = {
  [Product in Products]: {
    color: string
    icon: string
    text: string
    title: string
    app?: string
    to?: string
  }
}

const productsUI = (formatMessage: FormatMessage): Partial<ProductList> => ({
  [Products.perks]: {
    color: theme.colors.products.perks,
    icon: IconTypes.perks,
    text: formatMessage({id: "platform.products.perks.text"}),
    title: formatMessage({id: "platform.products.perks.title"})
  },
  [Products.medical]: {
    color: theme.colors.products.medical,
    icon: IconTypes.medical,
    text: formatMessage({id: "platform.products.medical.text"}),
    title: formatMessage({id: "platform.products.medical.title"})
  },
  [Products.recognition]: {
    color: theme.colors.products.recognition,
    icon: IconTypes.celebration,
    text: formatMessage({id: "platform.products.recognition.text"}),
    title: formatMessage({id: "platform.products.recognition.title"})
  },
  [Products.wellness]: {
    color: theme.colors.products.wellness,
    icon: IconTypes.wellness,
    text: formatMessage({id: "platform.products.wellness.text"}),
    title: formatMessage({id: "platform.products.wellness.title"})
  },
  [Products.rewards]: {
    color: theme.colors.products.rewards,
    icon: IconTypes.celebration,
    text: formatMessage({id: "platform.products.rewards.text"}),
    title: formatMessage({id: "platform.products.rewards.title"})
  },
  [Products.cultureHub]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.cultureHub,
    text: "",
    title: formatMessage({id: "platform.products.cultureHub.title"})
  },
  [Products.ctw]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.circle,
    text: "",
    title: formatMessage({id: "platform.products.ctw.title"}),
    app: "/benefits",
    to: ctwURL
  },
  [Products.cycleToWork]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.circle,
    text: "",
    title: formatMessage({id: "platform.products.ctw.title"})
  },
  [Products.he]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.circle,
    text: "",
    title: formatMessage({id: "platform.products.he.title"}),
    app: "/benefits",
    to: heURL
  },
  [Products.homeAndElectronics]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.circle,
    text: "",
    title: formatMessage({id: "platform.products.he.title"})
  },
  [Products.alp]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.circle,
    text: "",
    title: formatMessage({id: "platform.products.alp.title"}),
    app: "/benefits",
    to: alpURL
  },
  [Products.annualLeavePurchase]: {
    color: theme.colors.greys.grey20,
    icon: IconTypes.circle,
    text: "",
    title: formatMessage({id: "platform.products.alp.title"})
  },
  [Products.onlineGP]: {
    color: theme.colors.products.medical,
    icon: IconTypes.perks,
    text: formatMessage({id: "platform.products.onlineGP.title"}),
    title: formatMessage({id: "platform.products.onlineGP.title"})
  },
  [Products.carScheme]: {
    title: formatMessage({id: "platform.products.carScheme.title"})
  },
  [Products.payrollGiving]: {
    title: formatMessage({id: "platform.products.payrollGiving.title"})
  },
  [Products.salaryFinance]: {
    title: formatMessage({id: "platform.products.salaryFinance.title"})
  },
  [Products.healthCashPlan]: {
    title: formatMessage({id: "platform.products.healthCashPlan.title"})
  },
  [Products.gymMembership]: {
    title: formatMessage({id: "platform.products.gymMembership.title"})
  },
  [Products.pensionAdvantage]: {
    title: formatMessage({id: "platform.products.pensionAdvantage.title"})
  },
  [Products.travelAndLeisure]: {
    title: formatMessage({id: "platform.products.travelAndLeisure.title"})
  }
})

export default productsUI
